import React from 'react'
import TableContent from '../../components/TableContent'
const url = 'connector/onedrive'
const item = 'OneDrive'
const items = 'OneDrive'

const ConnectorOneDrive = () => {
  return <TableContent url={url} type={'connector-onedrive'} item={item} items={items} />
}
export default ConnectorOneDrive
